let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5u3kg")).then(() => parcelRequire('5OaW1'));